var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TextInputConfiguration',{attrs:{"controller":_vm.OrderStringCtrller,"sizeinput":'sm',"forcerow":true}}),_c('TextInputConfiguration',{attrs:{"controller":_vm.WindowStringCtrller,"sizeinput":'sm',"forcerow":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }